import styled, { css } from "styled-components";

import { check, plus } from "images";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled.div<any>`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 926px;
`;

const Message1Wrap = styled.div`
   width: 380px;
   padding: 50px 0 85px 0;
`;
const Message2Wrap = styled.div`
   width: 380px;
   padding: 66px 0 44px 0;
`;
const Divider = styled.div`
   background-color: ${typography.other.color.gray[3]};
   width: 100%;
   height: 1px;
`;
const Img = styled.img`
   display: block;
   height: 32px;
`;

const Title1 = styled.div`
   font-weight: 700;
   font-size: 25px;
   line-height: 36px;
   letter-spacing: -0.03em;
   margin-top: 13px;
`;

const Title2 = styled.div`
   ${typography.other.t1}
   margin-top: 13px;
`;
const Text = styled.div<any>`
   ${typography.other.t8}
   line-height: 22px;
   white-space: nowrap;
   ${({ css }) => css}
`;

const Purple = styled.span`
   color: ${typography.other.color.purple[0]};
`;

export default function OrganismSuccess(props: PropsType) {
   return (
      <Wrap className={props.className} style={props.style} css={props.css}>
         <Message1Wrap>
            <Img src={check} />
            <Title1>
               전시 등록 요청이
               <br />
               <Purple>정상적으로 완료</Purple>되었습니다.
            </Title1>
            <Text
               css={css`
                  margin-top: 33px;
               `}>
               영업일 기준 1-3일 이내로 승인이 완료되며, 추가 문의사항이 있을 시<br />
               채널톡 문의 혹은 아트맵 전시지원팀(contact@art-map.co.kr)로 연락바랍니다.
            </Text>
         </Message1Wrap>
         <Divider></Divider>
         <Message2Wrap>
            <Img src={plus} />
            <Title2>
               <Purple>전시회 홍보</Purple>를 원하시나요?
            </Title2>
            <Text
               css={css`
                  margin-top: 27px;
               `}>
               수 많은 전시관, 작가들이 아트맵에서 전시를 홍보하고 있습니다.
               <br />
               7만 회 이상의 앱 다운로드 수, 통합 4.3만 명의 SNS 팔로워의
               <br />
               탄탄한 아트맵 회원층으로 효과적인 전시회 홍보를 진행하세요.
            </Text>
         </Message2Wrap>
      </Wrap>
   );
}
